import { required } from 'vuelidate/lib/validators';

const conditionValidations = {
    field: {
        required
    },
    value: {
        required
    }
};

const conditionGroupValidations = {
    $each: {
        children: {
            required, //Require at least a single condition
            $each: conditionValidations
        }
    }
};

export {
    conditionValidations,
    conditionGroupValidations
}